// Core
import { NavigationGuard } from "vue-router";
import router from "@/router";
import { until } from "@vueuse/core";

// Stores
import pinia from "@/store/pinia";

// Services
import { sentryService } from "@/core/services/sentry/sentryService";

// Stores
import { useTeamStore } from "@/store/team";

const requireValidSubscription: NavigationGuard = async (_to, _from, next) => {
  try {
    const teamStore = useTeamStore(pinia);

    // Aguarda o carregamento dos dados do team store se estiver carregando
    if (teamStore.loading) {
      await until(() => teamStore.loading).toBe(false);
    }

    if (teamStore.isPlanInvalid || teamStore.isSubscriptionLate) {
      next({ name: "Plans" });
    } else {
      next();
    }
  } catch (error) {
    // Capturar erro no Sentry antes de redirecionar
    sentryService.captureError(
      error,
      "subscription-guard-error",
      {
        title: "Erro ao validar assinatura",
        message: error instanceof Error ? error.message : "Erro desconhecido ao verificar assinatura"
      },
      {
        guard: "requireValidSubscription",
        to: _to.fullPath,
        from: _from.fullPath,
        error_source: "router"
      }
    );
    
    // Cancel current navigation and redirect to error page without triggering guards
    next(false);
    router.replace({ name: "500" });
  }
};

export default requireValidSubscription;
